import { render, staticRenderFns } from "./Legacy.vue?vue&type=template&id=3922c38e&scoped=true"
import script from "./Legacy.vue?vue&type=script&lang=js"
export * from "./Legacy.vue?vue&type=script&lang=js"
import style0 from "./Legacy.vue?vue&type=style&index=0&id=3922c38e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3922c38e",
  null
  
)

export default component.exports